module.exports = "https://img1.huilianyi.com/c/icon4.c9efa75908.appcore.png";